interface ITab {
  value: string;
}

export const getInitialTab = (tabs: ITab[]): string => {
  return tabs.length > 0 ? tabs[0].value : '';
};
